import React from "react";
import { FormGroup, Input } from "reactstrap";
import moment from "moment";
import "react-image-crop/dist/ReactCrop.css";
class ArticleForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  formatTime(dateString) {
    return moment(dateString).format("YYYY-MM-DD");
  }

  render() {
    return (
      <div>
        <FormGroup>
          <label className="form-control-label" htmlFor="example-text-input">
            標題
          </label>
          <Input
            id="example-text-input"
            type="text"
            value={this.props.data.title}
            onChange={(e) => this.props.onTextInputChange(e, "title")}
          />
        </FormGroup>
        <FormGroup>
          <label
            className="form-control-label"
            htmlFor="exampleFormControlSelect1"
          >
            投放位置
          </label>
          <Input
            id="positionSelect"
            type="select"
            onChange={(e) => this.props.handleCheckBoxChange(e)}
          >
            <option
              selected={
                this.props.data.category_ids
                  ? this.props.data.category_ids.indexOf("right") !== -1
                  : false
              }
              value={"right"}
            >
              側邊廣告
            </option>
            <option
              selected={
                this.props.data.category_ids
                  ? this.props.data.category_ids.indexOf("top") !== -1
                  : false
              }
              value={"top"}
            >
              置頂廣告
            </option>
          </Input>
        </FormGroup>
        <FormGroup>
          <label className="form-control-label" htmlFor="example-text-input">
            網站連結
          </label>
          <Input
            id="example-text-input"
            type="text"
            value={this.props.data.website}
            onChange={(e) => this.props.onTextInputChange(e, "website")}
          />
        </FormGroup>
        <FormGroup>
          <label className="form-control-label" htmlFor="areaSelect">
            投放區域
          </label>
          <Input
            id="areaSelect"
            type="select"
            onChange={(e) => this.props.onTextInputChange(e, "area")}
          >
            {this.props.areaOptions.map((_, i) => (
              <option
                key={`area-${i}`}
                selected={this.props.data.area === _}
                value={_}
              >
                {_.toUpperCase()}
              </option>
            ))}
          </Input>
        </FormGroup>

        <FormGroup>
          <label className="form-control-label" htmlFor="example-text-input">
            聯繫人
          </label>
          <Input
            id="example-text-input"
            type="text"
            value={this.props.data.contact}
            onChange={(e) => this.props.onTextInputChange(e, "contact")}
          />
        </FormGroup>

        <FormGroup>
          <label className="form-control-label" htmlFor="example-text-input">
            電話
          </label>
          <Input
            id="example-text-input"
            type="text"
            value={this.props.data.phone}
            onChange={(e) => this.props.onTextInputChange(e, "phone")}
          />
        </FormGroup>

        <FormGroup>
          <label className="form-control-label" htmlFor="example-text-input">
            郵箱（選填）
          </label>
          <Input
            id="example-text-input"
            type="text"
            value={this.props.data.email}
            onChange={(e) => this.props.onTextInputChange(e, "email")}
          />
        </FormGroup>
      </div>
    );
  }
}

export default ArticleForm;
